import { features } from '@/mocks/homeContent';

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择禁漫天堂
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
            我们致力于为每一位漫画爱好者提供极致的阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-100 rounded-xl p-6 hover:bg-background-200/70 transition-colors duration-200 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}